/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateUnitDto } from '../models';
// @ts-ignore
import type { UnitConfigDto } from '../models';
// @ts-ignore
import type { UpdateUnitDto } from '../models';
/**
 * QuestionUnitsApi - axios parameter creator
 * @export
 */
export const QuestionUnitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateUnitDto} createUnitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionUnitsControllerCreateUnit: async (createUnitDto: CreateUnitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUnitDto' is not null or undefined
            assertParamExists('questionUnitsControllerCreateUnit', 'createUnitDto', createUnitDto)
            const localVarPath = `/api/question-units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUnitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionUnitsControllerGetQuestionUnits: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/question-units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} unitId 
         * @param {UpdateUnitDto} updateUnitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionUnitsControllerUpdateUnit: async (unitId: string, updateUnitDto: UpdateUnitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitId' is not null or undefined
            assertParamExists('questionUnitsControllerUpdateUnit', 'unitId', unitId)
            // verify required parameter 'updateUnitDto' is not null or undefined
            assertParamExists('questionUnitsControllerUpdateUnit', 'updateUnitDto', updateUnitDto)
            const localVarPath = `/api/question-units/{unitId}`
                .replace(`{${"unitId"}}`, encodeURIComponent(String(unitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUnitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionUnitsApi - functional programming interface
 * @export
 */
export const QuestionUnitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionUnitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateUnitDto} createUnitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionUnitsControllerCreateUnit(createUnitDto: CreateUnitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionUnitsControllerCreateUnit(createUnitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionUnitsApi.questionUnitsControllerCreateUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionUnitsControllerGetQuestionUnits(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitConfigDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionUnitsControllerGetQuestionUnits(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionUnitsApi.questionUnitsControllerGetQuestionUnits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} unitId 
         * @param {UpdateUnitDto} updateUnitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionUnitsControllerUpdateUnit(unitId: string, updateUnitDto: UpdateUnitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionUnitsControllerUpdateUnit(unitId, updateUnitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionUnitsApi.questionUnitsControllerUpdateUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionUnitsApi - factory interface
 * @export
 */
export const QuestionUnitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionUnitsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateUnitDto} createUnitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionUnitsControllerCreateUnit(createUnitDto: CreateUnitDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.questionUnitsControllerCreateUnit(createUnitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionUnitsControllerGetQuestionUnits(options?: RawAxiosRequestConfig): AxiosPromise<Array<UnitConfigDto>> {
            return localVarFp.questionUnitsControllerGetQuestionUnits(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} unitId 
         * @param {UpdateUnitDto} updateUnitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionUnitsControllerUpdateUnit(unitId: string, updateUnitDto: UpdateUnitDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.questionUnitsControllerUpdateUnit(unitId, updateUnitDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionUnitsApi - object-oriented interface
 * @export
 * @class QuestionUnitsApi
 * @extends {BaseAPI}
 */
export class QuestionUnitsApi extends BaseAPI {
    /**
     * 
     * @param {CreateUnitDto} createUnitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionUnitsApi
     */
    public questionUnitsControllerCreateUnit(createUnitDto: CreateUnitDto, options?: RawAxiosRequestConfig) {
        return QuestionUnitsApiFp(this.configuration).questionUnitsControllerCreateUnit(createUnitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionUnitsApi
     */
    public questionUnitsControllerGetQuestionUnits(options?: RawAxiosRequestConfig) {
        return QuestionUnitsApiFp(this.configuration).questionUnitsControllerGetQuestionUnits(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} unitId 
     * @param {UpdateUnitDto} updateUnitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionUnitsApi
     */
    public questionUnitsControllerUpdateUnit(unitId: string, updateUnitDto: UpdateUnitDto, options?: RawAxiosRequestConfig) {
        return QuestionUnitsApiFp(this.configuration).questionUnitsControllerUpdateUnit(unitId, updateUnitDto, options).then((request) => request(this.axios, this.basePath));
    }
}

